/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportConsequencesFromBIP$Params {
  patientID?: number;
}

export function ImportConsequencesFromBIP(http: HttpClient, rootUrl: string, params?: ImportConsequencesFromBIP$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, ImportConsequencesFromBIP.PATH, 'post');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

ImportConsequencesFromBIP.PATH = '/api/Supervisor/ImportConsequencesFromBIP';
